export default __webpack_public_path__ + "static/media/wifi.fa29f2dc.svg";